'use client'

import { cx } from 'classix'
import { type ReactNode, useEffect, useRef } from 'react'
import styles from './CookiesWrapper.module.css'

interface Props {
	readonly children: ReactNode
}

export const CookiesWrapper = ({ children }: Props) => {
	const dialogRef = useRef<HTMLDialogElement>(null)

	useEffect(() => {
		const dialog = dialogRef.current
		const blockEscape = (e: KeyboardEvent) => {
			if (e.key === 'Escape') {
				e.preventDefault()
				e.stopPropagation()
			}
		}

		if (dialog) {
			dialog.showModal()
			dialog.addEventListener('keydown', blockEscape)
		}

		return () => {
			if (dialog) {
				dialog.removeEventListener('keydown', blockEscape)
			}
		}
	}, [])

	return (
		<dialog
			ref={dialogRef}
			aria-modal='true'
			aria-labelledby='cbanner-title'
			className={cx(styles.cookiesWrapper, styles.middle)}
			data-testid='cookies.layout'
			role='alertdialog'
		>
			{children}
		</dialog>
	)
}
